import styled from 'styled-components';
import { Button } from '@m/alchemy-ui/Button';
import { color, units } from '@m/alchemy-ui/theme';

export const FormFooter = styled.div`
  padding-top: ${units(3)};
  border-top: 1px solid ${color('lineContrast', { palette: 'structural' })};
  text-align: right;
`;

export const FormElement = styled.div`
  border-top: 1px solid ${color('lineContrast', { palette: 'structural' })};
  margin-bottom: ${units(3)};
  padding-top: ${units(3)};
`;

export const ClearButton = styled(Button)`
  margin-right: ${units(2)};
`;
